let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k4GEv")).then(() => parcelRequire('bw5U3'));